import { useAuthStore } from '@core/stores/auth-store'
import { ROUTES } from '@platform/router/paths'
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/(auth)')({
  beforeLoad: () => {
    if (useAuthStore.getState().isLogged()) throw redirect({ to: ROUTES.root })
  },
  component: Outlet,
})
